import { z } from 'zod'

export const countWords = (input: string): number => {
  z.string().parse(input)

  return input.trim().split(/\s+/).length
}

export const stripHTMLTags = (input: string): string => {
  z.string().parse(input)

  return input.replace(/<\/?[^>]+(>|$)/g, '')
}

/**
 * count the occurrences of a substring, while excluding cases where the substring appears between words and also accounting for special characters at the start & end of the substring
 *
 * @example
 * const str = "<h1>Hello, hello! Say hello to the world.</h1>";
 * getSubstringCount(str, "hello"); // result => 3
 * getSubstringCount(str, "lo"); // result => 0
 */
export function getSubstringCount(str: string, substring: string) {
  const regex = new RegExp(`(?:^|\\W)${substring}(?=\\W|$)`, 'gi')
  const matches = str.match(regex)
  return matches ? matches.length : 0
}

/**
 * truncate text from between by add ... in the middle
 *
 * @example
 * const str = "Hello, hello! Say hello to the world.";
 * truncateTextFromBetween(str, 15); // result => 'Hello,...world.'
 */
export function truncateTextFromBetween(text: string, maxLength: number) {
  if (text.length <= maxLength) {
    return text
  }

  const ellipsis = '...'
  const truncatedLength = maxLength - ellipsis.length
  const startLength = Math.ceil(truncatedLength / 2)
  const endLength = Math.floor(truncatedLength / 2)

  const truncatedText =
    text.substring(0, startLength) +
    ellipsis +
    text.substring(text.length - endLength)
  return truncatedText
}
